import React from "react";
import "./App.css";
import AppRoutes from "./layouts/navigation/AppRoutes";
import { ComponentNavigation } from "./layouts/navigation/ComponentNavigation";
import ResponsiveFallback from "./layouts/components/responsiveFallback/ResponsiveFallback";

function App() {
  return (
    <ResponsiveFallback fallbackMessage="MoltechR is best viewed on larger screens. Please switch to a bigger device for optimal use.">
      <AppRoutes componentRoutes={ComponentNavigation} />
    </ResponsiveFallback>
  );
}

export default App;
